import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0aec1e76&scoped=true&lang=pug&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style1 from "./main.vue?vue&type=style&index=1&id=0aec1e76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec1e76",
  null
  
)

export default component.exports